<template>
  <component :is="iconComponent" :class="iconClass" />
</template>

<script>
import CheckDoubleIcon from '@/assets/icons/check-double.svg';
import CheckSingleIcon from '@/assets/icons/check-single.svg';
import ErrorIcon from '@/assets/icons/error-icon.svg';
import ClockIcon from '@/assets/icons/clock.svg';

export default {
  components: {
    CheckDoubleIcon,
    CheckSingleIcon,
    ClockIcon,
    ErrorIcon,
  },
  props: {
    createdAt: {
      type: String,
    },
    deliveredAt: {
      type: String,
    },
    errorCode: {
      type: [String, null],
    },
    typeUser: {
      type: String,
    },
    readAt: {
      type: String,
    },
  },
  computed: {
    iconComponent() {
      if (this.createdAt) {
        if (this.errorCode && this.typeUser === 'User') {
          return 'error-icon';
        }

        if (this.deliveredAt) {
          return 'check-double-icon';
        }
        return 'check-single-icon';
      }
      return 'clock-icon';
    },
    iconClass() {
      return [
        'message__footer-icon',
        {
          'message__footer-icon--is-read': this.readAt,
          'message__footer-icon--squared': !this.createdAt,
          'message__footer-icon-error': this.errorCode,

        },
      ];
    },
  },
};
</script>
